var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.3,
    viewBox: "0 0 16 15.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(0 -43.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11196",
    "data-name": "Group 11196",
    transform: "translate(0.849 46.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11195",
    "data-name": "Group 11195",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21055",
    "data-name": "Path 21055",
    d: "M35.107,126.5A1.693,1.693,0,1,0,36.8,128.2,1.695,1.695,0,0,0,35.107,126.5Zm0,2.485a.728.728,0,0,1-.814-.792c0-.513.3-.751.814-.751s.829.237.829.751A.739.739,0,0,1,35.107,128.989Z",
    transform: "translate(-33.414 -126.504)",
    fill: "#2a292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11200",
    "data-name": "Group 11200",
    transform: "translate(8.779 46.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11199",
    "data-name": "Group 11199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21057",
    "data-name": "Path 21057",
    d: "M346.987,126.5a1.693,1.693,0,1,0,1.693,1.693A1.695,1.695,0,0,0,346.987,126.5Zm0,2.552a.787.787,0,0,1-.825-.859.751.751,0,0,1,.825-.812.764.764,0,0,1,.841.812A.8.8,0,0,1,346.987,129.056Z",
    transform: "translate(-345.294 -126.504)",
    fill: "#2a292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11194",
    "data-name": "Group 11194",
    transform: "translate(0 49.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11193",
    "data-name": "Group 11193",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21054",
    "data-name": "Path 21054",
    d: "M11.095,231.107H9.822a1.346,1.346,0,0,0-.5.1,1.98,1.98,0,0,0-1.7-1.525H5.375a1.98,1.98,0,0,0-1.7,1.525,1.346,1.346,0,0,0-.5-.1H1.9c-1.05,0-1.9,1.248-1.9,2.782v2.971c0,.92.513,1.669,1.142,1.669H11.856c.63,0,1.142-.749,1.142-1.669v-2.971C13,232.355,12.144,231.107,11.095,231.107Zm-7.624,1.355,0,4.955H1.142a.611.611,0,0,1-.2-.556v-2.971a2.835,2.835,0,0,1,.246-1.151,1.053,1.053,0,0,1,.718-.46H3.176c.1,0,.2.146.294.184C3.468,232.523,3.471,232.4,3.471,232.462Zm5.121,4.955H4.5v-4.955a2.95,2.95,0,0,1,.238-1.08,1.089,1.089,0,0,1,.633-.5H7.624a1.247,1.247,0,0,1,.737.5,2.438,2.438,0,0,1,.23,1.08Zm3.645-.556c0,.307-.171.556-.381.556H9.523v-4.955c0-.062,0-.034,0-.095a.85.85,0,0,1,.3-.089h1.272c.63,0,1.142.69,1.142,1.611Z",
    transform: "translate(0 -229.68)",
    fill: "#2a292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11198",
    "data-name": "Group 11198",
    transform: "translate(4.246 43.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11197",
    "data-name": "Group 11197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21056",
    "data-name": "Path 21056",
    d: "M169.224,43.729a2.262,2.262,0,1,0,2.262,2.262A2.264,2.264,0,0,0,169.224,43.729Zm0,3.482a1.226,1.226,0,1,1,1.233-1.22A1.086,1.086,0,0,1,169.224,47.211Z",
    transform: "translate(-166.962 -43.729)",
    fill: "#2a292b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11201",
    "data-name": "Group 11201",
    transform: "translate(8.414 50.716)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4089",
    "data-name": "Rectangle 4089",
    width: 7.586,
    height: 8.313,
    rx: 3.793,
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2175",
    d: "M19.154,16a.452.452,0,0,0-.447.458v.491a2.247,2.247,0,0,0-.792.332l-.346-.346a.437.437,0,0,0-.341-.145.456.456,0,0,0-.3.783l.348.348a2.245,2.245,0,0,0-.331.792h-.49a.451.451,0,1,0,0,.9h.492a2.247,2.247,0,0,0,.33.785l-.351.351a.451.451,0,1,0,.638.638l.35-.35a2.246,2.246,0,0,0,.79.331v.491a.451.451,0,1,0,.9,0v-.49a2.245,2.245,0,0,0,.789-.331l.353.353a.451.451,0,1,0,.638-.638l-.351-.351a2.246,2.246,0,0,0,.331-.789h.492a.451.451,0,1,0,0-.9h-.49a2.246,2.246,0,0,0-.332-.8l.348-.348a.451.451,0,1,0-.636-.638l-.349.349a2.245,2.245,0,0,0-.791-.331v-.49A.45.45,0,0,0,19.155,16Zm.006,1.805a1.354,1.354,0,1,1-1.354,1.354A1.347,1.347,0,0,1,19.16,17.805Z",
    transform: "translate(-15.365 -15.003)",
    fill: "#2a292b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.bfb1c1fd0a347bc93a5087af25fe400c.svg";
export { ForwardRef as ReactComponent };